import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { IUIDefaultViewModel } from "../../services/ui-personalization-data-service/Models";

export type MutationContextType = {
    previous: IUIDefaultViewModel[] | undefined;
};

export type UseDeleteUserDefaultViewParameters = {
} & BaseUseMutationParameters<void, number>;

export function useDeleteUserDefaultView({
    onError,
    onSuccess
}: UseDeleteUserDefaultViewParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, number, MutationContextType>(
        (id) => {
            return UIPersonalizationDataService.deleteUserDefaultView(id);
        },
        {
            onMutate: async (id: number) => {

                await queryClient.cancelQueries(keys.all);

                const previous = queryClient.getQueryData<IUIDefaultViewModel[]>("list");

                queryClient.setQueryData<IUIDefaultViewModel[]>(
                    keys.list(),
                    (old: IUIDefaultViewModel[] | undefined) => {
                        const copy = old?.filter(p => p.id !== id) ?? [];
                        return copy;
                    }
                );

                return {
                    previous: previous
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_, error, preset, context) => {

                if (error && context?.previous) {
                    queryClient.setQueryData<IUIDefaultViewModel[]>(
                        keys.list(),
                        context?.previous
                    );
                }

                if (!error) {
                    queryClient.invalidateQueries(keys.list());
                }
            }
        }
    );
}
